import type { WordTrackChangeRevisionData } from './types';
import { Mark, mergeAttributes } from '@tiptap/core';
import dayjs from 'dayjs';

export const MARK_FORMAT_REVISION = 'formatRevision';

// 형식 변경 리비전 마크
const FormatRevision = Mark.create({
    name: MARK_FORMAT_REVISION,
    addAttributes() {
        const defaultRevision: WordTrackChangeRevisionData = {
            id: crypto.randomUUID(),
            authorInfo: {
                id: null,
                displayName: 'Unnamed',
            },
            createdAt: dayjs().toISOString(),
        };
        return {
            revision: {
                default: defaultRevision,
                parseHTML: element => JSON.parse(element.dataset.revision || 'null') || defaultRevision,
                renderHTML: attributes => {
                    return {
                        'data-revision': JSON.stringify(attributes.revision),
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-format-revision]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes, { 'data-format-revision': '' }), 0];
    },
});

export default FormatRevision;
